export const SET_SELECTED_PLUGIN = 'plugins/set-selected-plugin';
export const SET_PLUGINS = 'plugins/set-plugins';
